import moment from 'moment';
const view_day_ar =  function(day)
{
    var day_en   = new Date(moment(day).format("yyyy-MM-DD"));
    switch(moment(day_en).format("dddd")) {
        case 'Saturday':
          return 'السبت';
        case 'Sunday':
            return 'الأحد';
        case 'Monday':
          return 'الإثنين';
        case 'Tuesday':
            return 'الثلاثاء';
        case 'Wednesday':
          return 'الأربعاء';
        case 'Thursday':
            return 'الخميس';
        case 'Friday':
            return 'الجمعة';
        default:
          return null
      }
}
export const view_month_ar =  function(month)
{
  var month_en = new Date(moment(month).format("YYYY-MM-DD"));
  var monthName = moment(month_en).format("MMMM");

  switch(monthName) {
      case 'January':   return 'يناير';
      case 'February':  return 'فبراير';
      case 'March':     return 'مارس';
      case 'April':     return 'أبريل';
      case 'May':       return 'مايو';
      case 'June':      return 'يونيو';
      case 'July':      return 'يوليو';
      case 'August':    return 'أغسطس';
      case 'September': return 'سبتمبر';
      case 'October':   return 'أكتوبر';
      case 'November':  return 'نوفمبر';
      case 'December':  return 'ديسمبر';
      default:          return monthName;
  }
}
export const View_Day = (data)=>{
    return (
        <strong >
            {moment(data.day).format('yyyy-MM-DD')}
            <br></br>
            {view_day_ar(data.day)}
        </strong>
    )
}
